import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

function PrivacyPolicy(): React.ReactElement {
    return (
        <Container component="main" maxWidth="md">
            <Box sx={{ mt: 8, mb: 2 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Privacy policy
                </Typography>
                <Typography variant="body1" paragraph>
                    Welcome to our website. If you continue to browse and use
                    this website, you are agreeing to comply with and be bound
                    by the following terms and conditions of use, which together
                    with our privacy policy govern [Company Name]s relationship
                    with you in relation to this website.
                </Typography>
                <Typography variant="body1" paragraph>
                    fndjkafjdask;f j
                </Typography>
                {/* Add more sections as needed */}
            </Box>
        </Container>
    )
}

export default PrivacyPolicy
